/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ReportRun } from '../models/V1ReportRun';
import { HttpFile } from '../http/http';

/**
* ListReportRunsResponse carries the page of runs and pagination state.
*/
export class V1ListReportRunsResponse {
    /**
    * The runs in this page.
    */
    'reportRuns'?: Array<V1ReportRun>;
    /**
    * Total runs available across all pages, for the filter applied.
    */
    'totalSize'?: number;
    /**
    * Token to pass as page_token on the next call. Empty when the last page has been returned.
    */
    'nextPageToken'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "reportRuns",
            "baseName": "report_runs",
            "type": "Array<V1ReportRun>",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListReportRunsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

